import React, { useEffect, useState, useContext } from "react";
import Modal from "common/Modal";
import ActionsContext from "common/ActionsContext";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import SelectInput from "common/SelectInput";

const doesNothing = () => {};

let loaded = null;

const fetchSignatures = () =>
  loaded = fetch("/js/signatures.json")
    .then( response => response.json())

const asOptions = ({ name }) => ({ label: name, value: name });

const SelectPredefined = ({ ...settings }) => (
  <SelectInput
    name="group"
    icon="list"
    label="Predefined Signatures"
    className="input-control align-left"
    {...settings}
  />
);

const AddPredefinedSignatureModal = ({
  cliName = "",
  signal = "add-predefined-signatures",
  title = "Add Signatures File",
  doBatch = doesNothing,
  icon = "add_circle",
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const actions = useContext(ActionsContext);
  const [signatures, setSignatures] = useState([]);
  const doLoad = () =>
    (loaded || fetchSignatures()).then(setSignatures);

  const doOpen = () => {
    setError(null);
    setOpen(true);
  };
  const doClose = () => {
    setOpen(false);
  };
  useEffect(() => actions.recv(signal, doOpen), [cliName]);
  useEffect(() => {
    if (open === true) {
      doLoad();
    }
  }, [open]);

  if (open !== true) {
    return null;
  }
  const ofGroup = (group) =>
    (signatures.find(({ name }) => name === group) ||
      console.warn(`no domains found for ${group}`) || { domains: [] })[
      "domains"
    ];

  const doApplyAndClose = ({ group }) => {
    try {
      doBatch(ofGroup(group)).then(doClose);
    } catch (error) {
      setError(String(error));
      throw error;
    }
    return false;
  };
  return (
    <Modal
      title={title}
      superIcon={icon}
      onApply={doApplyAndClose}
      onClose={doClose}
      closeLabel="CANCEL"
      content={() => (
        <ColumnsGrid columns={2} minWidth="25ch" rowGap="0">
          <SelectPredefined
            className="full-width"
            defaultValue="Video streaming"
            options={signatures.map(asOptions)}
          />
        </ColumnsGrid>
      )}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

export default AddPredefinedSignatureModal;
